import {
  GET_ANSWER_FROM_QUERY,
  GET_ANSWER_FROM_QUERY_SUCCESS,
  GET_ANSWER_FROM_QUERY_ERROR,

} from "./actionTypes"

const INIT_STATE = {
  answer_to_query: [],
  error: null,
  answer_to_query_loading: false,
}
const AnswerFromQuery = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_ANSWER_FROM_QUERY:
      return {
        ...state,
        answer_to_query_loading: true,
        error: null,
      }

    case GET_ANSWER_FROM_QUERY_SUCCESS:
      return {
        ...state,
        answer_to_query_loading: false,
        answer_to_query: action.payload,
        error: null,
      }


    case GET_ANSWER_FROM_QUERY_ERROR:
      return {
        ...state,
        answer_to_query_loading: false,
        error: action.payload
      }
    default:
      return state
  }
}

export default AnswerFromQuery
